import {SubAPI} from "./SubAPI";

export class ProjectWorkOrder extends SubAPI{

    get(props: {id: number}) {
        return this.fetcher.get<WorkOrderItem>("/api/project-work-order/item", props);
    }

    upsert(props: Partial<WorkOrderItem> & {
        setLinkedProducts: number[]
        setLinkedLogiCtrlStatuses: number[]
    }) {
        return this.fetcher.post<WorkOrderItem>("/api/project-work-order/item", props);
    }
}

export type WorkOrderItem = {
    id: number;
    project: number;
    description: string;
    createdAt: string;
    updatedAt: string;
    updatedBy: number;
    archived: boolean;
    status: string;
    projectWorkOrderItemPrice: number | null;
    projectFreeformChangePrice: number | null;
    projectFreeformChangeItemProducts: {id: number}[];
    logiCtrlLinks: {logictrlStatus: number | null, inventoryRequest: number | null}[];
}